import {AUTH_TOKEN, AUTH_USER_KEY} from "../../util/constants";
import AuthService from "../../services/AuthService";
import {AUTH_ERROR, AUTH_LOGOUT, AUTH_REQUEST, AUTH_SUCCESS, AUTH_USER} from "../actions/auth";
import {defineAbilitiesFor} from "../../util/abilities";
import Vue from "vue";


const state = {
    token: localStorage.getItem(AUTH_TOKEN) || '',
    status: '',
    hasLoadedOnce: false,
    user: localStorage.getItem(AUTH_USER_KEY) ? JSON.parse(localStorage.getItem(AUTH_USER_KEY)) : {}
}

const getters = {
    isAuthenticated: state => !!state.token,
    getUser: state => state.user,
};

const actions = {
    [AUTH_REQUEST]: ({commit, dispatch}, data) => {
        return new Promise((resolve, reject) => {
            commit(AUTH_REQUEST);
            AuthService.auth(data)
                .then(response => {
                    if (response) {
                        if (response.data.status === 'UNAUTHORIZED') {
                            commit(AUTH_ERROR);
                            reject("El usuario no existe o ha sido deshabilitado.");
                            return;
                        }
                        const token = response.data.payload.token;
                        commit(AUTH_SUCCESS, token);
                        commit(AUTH_USER, response.data.payload);
                        resolve(response);
                    }
                })
                .catch(err => {
                    commit(AUTH_ERROR, "Credenciales incorrectas");
                    localStorage.removeItem(AUTH_TOKEN);
                    reject(err);
                });
        });
    },
    [AUTH_LOGOUT]: ({commit, dispatch}) => {
        return new Promise((resolve, reject) => {
            commit(AUTH_LOGOUT);
            $('body').addClass('blank');

            resolve()
        })
    }
};

const mutations = {
    [AUTH_REQUEST]: (state) => {
        state.status = 'loading'
    },
    [AUTH_SUCCESS]: (state, token) => {
        state.status = 'success';
        state.token = token;
        state.hasLoadedOnce = true
        localStorage.setItem(AUTH_TOKEN, token);
    },
    [AUTH_ERROR]: (state) => {
        state.status = 'error';
        state.hasLoadedOnce = true
        localStorage.removeItem(AUTH_TOKEN)
        localStorage.removeItem(AUTH_USER_KEY)
    },
    [AUTH_LOGOUT]: (state) => {
        state.token = null
        state.user = null
        localStorage.removeItem(AUTH_TOKEN)
        localStorage.removeItem(AUTH_USER_KEY)
    },
    [AUTH_USER]: (state, claims) => {
        const user = {
            email: claims.sub,
            name: claims.name,
            role: claims.role
        };
        localStorage.setItem(AUTH_USER_KEY, JSON.stringify(user));
        defineAbilitiesFor(user);
        Vue.set(state, 'user', user)
    }
};

export default {
    state,
    getters,
    actions,
    mutations,
}



// WEBPACK FOOTER //
// ./src/store/modules/auth.js